import * as React from "react";
import { cn } from "../../utils/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: React.ReactNode;
  iconClass?: string;
  divClass?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ icon, iconClass, className, divClass, type = "text", error, ...props }, ref) => {
    return (
      <div className={`flex flex-col gap-1 ${divClass}`}>
        <div className={` w-full h-[42px] relative flex items-center`}>
          <input
            type={type}
            className={cn(
              "border text-gray-900 rounded-2xl h-full bg-white w-full py-[9px] px-[13px] text-base outline-none",
              error ? "border-red-500" : "border-border-gray",
              className
            )}
            ref={ref}
            {...props}
          />
          {icon && <div className={`absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 ${iconClass}`}>{icon}</div>}
        </div>
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
